var render, staticRenderFns
import script from "./BaseEdit.vue?vue&type=script&lang=js&"
export * from "./BaseEdit.vue?vue&type=script&lang=js&"
import style0 from "./BaseEdit.vue?vue&type=style&index=0&id=0ee80995&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee80995",
  null
  
)

export default component.exports